<template>
    <div class="lg:flex lg:flex-wrap lg:justify-end lg:align-items-center">
        <label v-if="label" id="listbox-label" class="block text-sm font-medium text-gray-700 lg:pr-2"> {{ label }}</label>
        <div class="relative flex w-6/12 lg:pr-2">
            <button type="button" @click="toggleShowOptions"
                    class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-pointer focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-500 sm:text-sm hover:border-indigo-400 hover:text-indigo-400 transition duration-300"
                    aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
                <span class="block truncate">{{ dropdownLabel }} </span>
                <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <icon-chevron-down class="h-5 w-5 transform transition-transform ease-in-out" :class="showOptions ? 'rotate-180': 'rotate-0'"></icon-chevron-down>
                </span>
            </button>

            <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <ul v-if="showOptions" v-click-outside="handleClickOutside"
                    class="absolute z-10 mt-10 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    tabindex="-1" role="listbox" aria-labelledby="listbox-label">
                    <li v-for="option in options"
                        @click="toggleSelectOption(option)"
                        class="text-gray-900 cursor-pointer select-none relative py-2 pl-3 pr-9 text-left"
                        id="listbox-option-0" role="option">
                        <span class="block truncate" :class="isSelected(option) ? 'font-semibold' : 'font-normal'"> {{ option | titlecase | pluralizeOnlyS }}</span>
                        <span v-if="isSelected(option)" class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                            <icon-check class="h-5 w-5"></icon-check>
                        </span>
                    </li>
                </ul>
            </transition>
        </div>
    </div>

</template>

<script>
export default {
    name: "SimpleDropdownWithMultiSelect",

    props: {
        options: {
            type: Array,
            required: true,
        },
        preSelectedOptions: {
            type: Array,
            required: false,
            default: () => []
        },
        label: {
            type: String,
            required: false,
            default: null
        }
    },

    data () {
        return {
            selectedOptions: this.preSelectedOptions,
            showOptions: false
        };
    },

    computed: {
        dropdownLabel () {
            if (this.selectedOptions.length <= 0) {
                return "All";
            }

            if (this.selectedOptions.length === 1) {
                return this.$options.filters.pluralizeOnlyS(this.$options.filters.titlecase(this.selectedOptions[0]));
            }

            return this.selectedOptions.length + " Selected";
        }
    },

    methods: {
        toggleShowOptions () {
            this.showOptions = !this.showOptions;
        },

        isSelected (option) {
            return this.selectedOptions.includes(option);
        },

        toggleSelectOption (option) {
            let index = this.selectedOptions.indexOf(option);

            if (index <= -1) {
                this.selectedOptions.push(option);
            } else {
                this.selectedOptions.splice(index, 1);
            }

            this.$emit("selected-options-changed", this.selectedOptions);
        },

        handleClickOutside () {
            if (!this.showOptions) {
                return;
            }

            this.toggleShowOptions();
        }

    }
};
</script>
